const locale = {
    ERROR: "Error",
    SUCCESS: "Success",
	UNKNOWNERROR: "Unknown error",
    SERVERBADRESPONSE: "Bad response from server",
    SESSIONEXPIRED: "Session has expired",
    EMPTYVALUE: "Empty Value",
    ERROR_GENERAL: "General error",
    ERROR_ESTABLISHCONNECTION: "Error establishing a secure connection",
    ERROR_PROCESSINGDATA: "Error processing the data",
    ERROR_COMMUNICATIONWITHSERVER: "Error communicating with the server",
};

export default locale;
